import { CircularMinus, CircularPlus } from '@components/icons'

interface Props {
  sliderValue: number
  setSliderValue: any
  mobile?: boolean
}

const SliderWithButtons = ({ sliderValue, setSliderValue, mobile }: Props) => {
  const handleChange = (e: any) => {
    setSliderValue(parseInt(e.target.value))
  }
  const handleLargerTile = () => {
    if (mobile ? sliderValue < 3 : sliderValue < 4) {
      setSliderValue(sliderValue + 1)
    }
  }
  const handleSmallerTile = () => {
    if (sliderValue > 1) {
      setSliderValue(sliderValue - 1)
    }
  }

  return (
    <>
      <div className="m-auto flex gap-3.5">
        <button onClick={handleSmallerTile}>
          <CircularMinus />
        </button>
        <div className="flex w-15 items-center">
          <input
            type="range"
            min="1"
            max={mobile ? '3' : '4'}
            value={sliderValue}
            onChange={handleChange}
            className="slider"
          />
        </div>
        <button onClick={handleLargerTile}>
          <CircularPlus />
        </button>
      </div>
      <style jsx global>
        {`
          .slider {
            -webkit-appearance: none;
            width: 100%;
            height: 2px;
            border-radius: 5px;
            background: #d8d8d8;
            outline: none;
            opacity: 1;
            -webkit-transition: 0.2s;
            transition: opacity 0.2s;
          }
          .slider:hover {
            opacity: 0.7;
          }

          .slider::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #646464;
            cursor: pointer;
          }

          .slider::-moz-range-thumb {
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #646464;
            cursor: pointer;
          }
        `}
      </style>
    </>
  )
}

export default SliderWithButtons
